export class MixMatchLevel {
    id: number;
    header_id: number;
    selection_level: number;
    purchase_quantity: number;
    description: string;
    created_at: string;
    updated_at: string;
}
